import keyMirror from 'keymirror'

export default keyMirror({
  ADD_LIQUIDITY: null,
  ADD_LIQUIDITY_MSG: null,
  ADD_LIQUIDITY_TX: null,
  CONNECT_METAMASK: null,
  CONNECT_WALLET: null,
  CLEAR_CURRENCY_AMOUNTS: null,
  CLOSE_CONFIRM_MODAL: null,
  CLOSE_MODAL: null,
  CLOSE_RIGHT_DRAWER: null,
  CLOSE_SNACK_BAR: null,
  ENTER_INPUT_AMOUNT: null,
  INIT_CHAIN_ID: null,
  INIT_PROVIDER: null,
  INIT_RESET_WALLET: null,
  LOCALE: null,
  MARKET_DATA_UPDATE: null,
  METAMASK_ACCOUNT_CHANGE: null,
  OPEN_MODAL: null,
  OPEN_CONFIRM_MODAL: null,
  OPEN_RIGHT_DRAWER: null,
  OPEN_SNACK_BAR: null,
  RESET_WALLET: null,
  SELECT_CURRENCY: null,
  SET_CURRENCY_AMOUNTS: null,
  SET_SELECTED_CURRENCIES: null,
  SET_CHAIN_ID: null,
  SET_PENDING_TRANSACTION: null,
  SET_PRESELECTED_WALLET: null,
  SET_PROVIDER: null,
  SET_PROVIDER_AND_SDKS_ERROR: null,
  SET_TRANSACTION_STATUS: null,
  SET_UPDATED_TRADE_ROUTE: null,
  SET_WALLET: null,
  TRANSACTION_MINED: null,
  UPDATE_TRADE_ROUTE: null,
  WALLET_SELECT: null
})
